import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReturnFormScreen } from '@/features/purchasing-returns/return-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * The return form is reached from a goods receipt (plan screen 5 names no
 * route for it): a `receiptId` search param carries which receipt is being
 * reversed, set by the "Return" action on `receipt-detail-screen.tsx`. A
 * direct visit with no `receiptId` has nothing to reverse, so it bounces to
 * the receipt list rather than rendering a form with no lines.
 */
export const Route = createFileRoute('/_authenticated/purchasing/returns/new')({
  validateSearch: (search: Record<string, unknown>): { receiptId: string } => ({
    receiptId: typeof search.receiptId === 'string' ? search.receiptId : '',
  }),
  beforeLoad: ({ context, search }) => {
    if (!hasGrant(context.queryClient, 'supplier_return.create')) {
      throw redirect({ to: '/purchasing/returns' })
    }
    if (!search.receiptId) {
      throw redirect({ to: '/purchasing/receipts' })
    }
  },
  component: SupplierReturnNewRoute,
})

function SupplierReturnNewRoute() {
  const { receiptId } = Route.useSearch()

  return <ReturnFormScreen receiptId={receiptId} />
}
